import { RootState } from "../types";

export const usersSelector = (state: RootState) => state.users.users;
export const companiesSelector = (state: RootState) => state.users.companies;
export const recommendationsSelector = (state: RootState) =>
  state.users.recommendations;
export const rolesSelector = (state: RootState) => state.users.roles;
export const questionReportCommentsSelector = (state: RootState) =>
  state.users.questionReportComments;
export const specializationsSelector = (state: RootState) =>
  state.users.specializations;
export const currentQuestionnaireSelector = (state: RootState) =>
  state.users.scroll.currentQuestionnaire;
export const currentRRMSelector = (state: RootState) =>
  state.users.scroll.currentRRM;
export const currentRRMQuestionnaireSelector = (state: RootState) =>
  state.users.scroll.currentRRMQuestionnaire;
export const currentProtocolSelector = (state: RootState) =>
  state.users.scroll.currentProtocol;
export const currentSMSSelector = (state: RootState) =>
  state.users.scroll.currentSMS;
export const currentComponentSelector = (state: RootState) =>
  state.users.scroll.currentComponent;
export const currentProtocolComponentSelector = (state: RootState) =>
  state.users.scroll.currentProtocolComponent;
export const currentUserSelector = (state: RootState) =>
  state.users.scroll.currentUser;
export const pendingReportAppointmentsSelector = (state: RootState) => state.users.pendingReportAppointments;
export const pendingReportInquiriesSelector = (state: RootState) => state.users.pendingReportInquiries;

